import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteEmail } from "../api/deleteEmail";

export const useDeleteEmail = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ endPoint, id, body }) => deleteEmail(endPoint, id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["allEmail"] });
    },
  });
};

